<template>
  <transition name="alert-fade">
    <div
    :id="id"
    class="status-alert"
    v-if="showAlert">
      <div class="content">
        <slot></slot>
      </div>
      <i
      v-if="closeBtn"
      class="fas fa-times"
      @click="$emit('update:showAlert', false)"></i>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: false
    },
    showAlert: {
      type: Boolean,
      required: true,
      default: false
    },
    closeBtn: {
      type: Boolean,
      required: false,
      default: false
    },
    autoHide: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {};
  },
  watch: {
    showAlert: async function(newValue) {
      if (this.autoHide == false) return;
      if (newValue == true) await this.hideTimeout();
    }
  },
  methods: {
    hideTimeout: function() {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(this.$emit('update:showAlert', false));
        }, 5000);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.alert-fade-enter-active, .alert-fade-leave-active {
  transition: opacity .3s;
}
.alert-fade-enter, .alert-fade-leave-to {
  opacity: 0;
}
.status-alert {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 1;
  border: 1px solid $wg_1;
  padding: 1rem 1.5rem;
  box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  background-color: $white;
}
.status-alert > i.fa-times {
  color: $bg_3;
  margin-left: 1rem;
  cursor: pointer;
}
</style>